/**
 *App Urls wrapper
*/
const Facades_Apps_Urls={
    
    //##########################################
    //PAGES URLS
    //##########################################

    _url_base_iss:function(param_cant_str)
    {
        /**
         * set the base url for iss
        */
        //OBJ CONTEXT
        var self=this;

        //check if this is beign run form `npm run serve` on localhost
        //if true use the local_url FMOH-ISS in the config file
        //else use the window origin
        if((window.location.origin).search("localhost")==-1)
        {
            return (window.location.origin)+"/"+param_cant_str;
        }
        else
        {
            return (CONFIG.URL_FMOH_ISS+param_cant_str);
        }
    },

    _url_base_spa:function(param_cant_str,param_username,param_form_name,param_form_id)
    {
        /**
         * set the base url for app main/ pages
        */
        //OBJ CONTEXT
        var self=this;

        return (
            //spa server route
            (window.location.origin)+"/"+param_username+"/"+param_form_name+"/report#/"+
            //the vue router routes
            param_cant_str+"/"+param_username+"/"+param_form_name+"/"+param_form_id
        );
    },

    _url_base_spa_public:function(param_cant_str,param_username,param_form_name,param_form_id)
    {
        /**
         * set the base url for app main/ pages
         * 
         * set as unprotected publica access route using the (public#) tag
        */
        //OBJ CONTEXT
        var self=this;

        return (
            //spa server route
            (window.location.origin)+"/"+param_username+"/"+param_form_name+"/report/public#/"+
            //the vue router routes
            param_cant_str+"/"+param_username+"/"+param_form_name+"/"+param_form_id
        );
    },

    //##########################################
    //LINKS TO FMOH_ISS
    //##########################################
    fmoh_iss_gen_img_link:function(
        param_username,
        param_form_id,
        param_form_name,
        param_file_name
    )
    {
        /**
         * generate a link to the submission imgs
        */
        //OBJ CONTEXT
        var self=this;

        var links={}

        links["small"]=self._url_base_iss("attachment/small?media_file="+param_username+"/attachments/"+param_form_id+"_"+param_form_name+"/"+param_file_name)
        links["medium"]=self._url_base_iss("attachment/medium?media_file="+param_username+"/attachments/"+param_form_id+"_"+param_form_name+"/"+param_file_name)

        return links
    },

    fmoh_iss_page_home:function(param_username)
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_iss(param_username)
    },

    //##########################################
    //LINKS TO App_Error_Pages
    //##########################################
    app_error_page_401:function(param_username,param_form_name,param_form_id)
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa("error/401",param_username,param_form_name,param_form_id);
    },
    app_error_page_404:function(param_username,param_form_name,param_form_id)
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa("/error/404",param_username,param_form_name,param_form_id);
    },

    //##########################################
    //ISS PROFILE
    //##########################################
    iss_profile:function(param_username,param_form_name,param_form_id)
    {
        //OBJ CONTEXT
        var self=this;

        return (window.location.origin)+"/"+param_username
    },

    //##########################################
    //MODULE module_core
    //##########################################
    module_core_page_index:function(param_username,param_form_name,param_form_id)
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_CORE,
            param_username,
            param_form_name,
            param_form_id
        );
    },

    //##########################################
    //MODULES generic
    //##########################################
    modules_page_srp_pdf:function(
        param_module_name,
        param_username,
        param_form_name,
        param_form_id,
        param_submission_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        //make iss pdf page unprotected
        //public access
        if(param_module_name == SPA_MODULE_NAME_PRIMARY_ISS)
        {
            return self._url_base_spa_public(
                param_module_name+"/srp/pdf",
                param_username,
                param_form_name,
                param_form_id+"/"+param_submission_id
            );
        }
        else
        {
            return self._url_base_spa(
                param_module_name+"/srp/pdf",
                param_username,
                param_form_name,
                param_form_id+"/"+param_submission_id
            );
        }
    },

    //##########################################
    //MODULE module_addon_form_bhcpf
    //##########################################
    module_addon_form_bhcpf_page_srp:function(
        param_username,
        param_form_name,
        param_form_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_BHCPF+"/srp",
            param_username,
            param_form_name,
            param_form_id
        );
    },
    module_addon_form_bhcpf_page_srp_pdf:function(
        param_username,
        param_form_name,
        param_form_id,
        param_submission_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_BHCPF+"/srp/pdf",
            param_username,
            param_form_name,
            param_form_id+"/"+param_submission_id
        );
    },
    module_addon_form_bhcpf_page_details:function(
        param_username,
        param_form_name,
        param_form_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_BHCPF+"/details",
            param_username,
            param_form_name,
            param_form_id
        );
    },

    //##########################################
    //MODULE module_addon_form_primary_iss
    //##########################################
    module_addon_form_primary_iss_page_srp:function(
        param_username,
        param_form_name,
        param_form_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_PRIMARY_ISS+"/srp",
            param_username,
            param_form_name,
            param_form_id
        );
    },
    module_addon_form_primary_iss_page_srp_pdf:function(
        param_username,
        param_form_name,
        param_form_id,
        param_submission_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_PRIMARY_ISS+"/srp/pdf",
            param_username,
            param_form_name,
            param_form_id+"/"+param_submission_id
        );
    },
    module_addon_form_primary_iss_page_details:function(
        param_username,
        param_form_name,
        param_form_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_PRIMARY_ISS+"/details",
            param_username,
            param_form_name,
            param_form_id
        );
    },

    //##########################################
    //MODULE module_addon_form_nhmis_dqa_odk
    //##########################################
    module_addon_form_nhmis_dqa_odk_page_srp:function(
        param_username,
        param_form_name,
        param_form_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_NHMIS_DQA_ODK+"/srp",
            param_username,
            param_form_name,
            param_form_id
        );
    },
    module_addon_form_nhmis_dqa_odk_page_srp_pdf:function(
        param_username,
        param_form_name,
        param_form_id,
        param_submission_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_NHMIS_DQA_ODK+"/srp/pdf",
            param_username,
            param_form_name,
            param_form_id+"/"+param_submission_id
        );
    },
    module_addon_form_nhmis_dqa_odk_page_details:function(
        param_username,
        param_form_name,
        param_form_id
    )
    {
        //OBJ CONTEXT
        var self=this;

        return self._url_base_spa(
            SPA_MODULE_NAME_NHMIS_DQA_ODK+"/details",
            param_username,
            param_form_name,
            param_form_id
        );
    }
}

/*
 *##########################################
 *EXPORTS
 *##########################################
*/
export {Facades_Apps_Urls};